import {
  AddressBookTabs,
  CardsThree,
  ChartBar,
  ChatsTeardrop,
  LinkedinLogo,
  PaperPlaneTilt,
  Rocket,
} from "@phosphor-icons/react";
import { useState } from "react";

import BadgeWrapper from "common/components/BadgeWrapper";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { useUnreadMessagesWebsocketContext } from "common/context/UnreadMessagesWebsocketContext";
import useWorkspaceDetails from "common/datahooks/useWorkspaceDetails";
import { getWhitelabelCustomization } from "common/helpers/utils";
import type { NavItemType } from "common/types";

import IntegrationsIcon from "assets/icons/integrations.svg?react";

export default function useNavItems() {
  const { id: workspaceId, permissions } = useSelectedWorkspaceContext();
  const { workspace } = useWorkspaceDetails(workspaceId);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  useUnreadMessagesWebsocketContext(({ unreadCount }) => {
    setUnreadMessagesCount(unreadCount);
  });

  const navItems: NavItemType[] = [
    {
      path: "home",
      label: "Analytics",
      icon: <ChartBar weight="fill" />,
    },
  ];

  if (
    workspace?.subscription?.status === "in_trial" &&
    !getWhitelabelCustomization()
  ) {
    navItems.unshift({
      path: "onboarding",
      label: "Onboarding",
      icon: <Rocket weight="fill" className="rotate-45" />,
    });
  }

  if (
    permissions.includes("accounts_full") ||
    permissions.includes("accounts_limited")
  ) {
    navItems.push({
      path: "accounts",
      label: "Accounts",
      icon: <LinkedinLogo weight="fill" />,
    });
  }

  if (
    permissions.includes("campaigns_full") ||
    permissions.includes("campaigns_limited")
  ) {
    navItems.push({
      path: "campaigns",
      label: "Campaigns",
      icon: <PaperPlaneTilt weight="fill" />,
    });
  }

  if (
    permissions.includes("templates_full") ||
    permissions.includes("templates_limited")
  ) {
    navItems.push({
      path: "templates",
      label: "Templates",
      icon: <CardsThree weight="fill" />,
    });
  }

  if (permissions.includes("leads_full")) {
    navItems.push({
      path: "leads",
      label: "Leads",
      icon: <AddressBookTabs weight="fill" />,
    });
  }

  if (
    permissions.includes("inbox_full") ||
    permissions.includes("inbox_limited")
  ) {
    navItems.push({
      path: "inbox",
      label: "Inbox",
      icon: unreadMessagesCount ? (
        <BadgeWrapper badgeClassName="-right-px top-px size-2 border-white">
          <ChatsTeardrop weight="fill" />
        </BadgeWrapper>
      ) : (
        <ChatsTeardrop weight="fill" />
      ),
      notifications: unreadMessagesCount,
    });
  }

  if (permissions.includes("integrations_full")) {
    navItems.push({
      path: "integrations",
      label: "Integrations",
      icon: <IntegrationsIcon />,
    });
  }

  return navItems;
}
